/**
 * Shared formatters for V3 widgets + landing page.
 */

export function formatMoney(val, currency = 'AED') {
    if (val === null || val === undefined || isNaN(val)) return '—';
    const n = Number(val);
    if (Math.abs(n) >= 1e9) return `${currency} ${(n / 1e9).toFixed(2)}B`;
    if (Math.abs(n) >= 1e6) return `${currency} ${(n / 1e6).toFixed(2)}M`;
    if (Math.abs(n) >= 1e3) return `${currency} ${(n / 1e3).toFixed(2)}K`;
    return `${currency} ${n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function formatNumber(val, decimals = 0) {
    if (val === null || val === undefined || isNaN(val)) return '—';
    return Number(val).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}

export function formatPct(val, decimals = 1) {
    if (val === null || val === undefined || isNaN(val)) return '—';
    const n = Number(val);
    const sign = n > 0 ? '+' : '';
    return `${sign}${n.toFixed(decimals)}%`;
}

export function formatCompactNumber(val) {
    if (val === null || val === undefined || isNaN(val)) return '—';
    const n = Number(val);
    if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
    if (Math.abs(n) >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
    return n.toFixed(0);
}

/**
 * Full numeric amount with thousands separators and at most 2 decimal places.
 * Use for tooltips, donut totals, and any place that displays a non-abbreviated value.
 */
export function formatAmount(val) {
    if (val === null || val === undefined || isNaN(val)) return '—';
    return Number(val).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
}
